import { FrontendEnvironmentSettings } from '@act/shared/environment';
import { DefaultPrivacyLevel, datadogRum } from '@datadog/browser-rum';

let userMonitoringInitialized = false;
let orientationListenerInitialized = false;
const safeActionPrefix = 'dd-safe-action-';

export const initializeUserMonitoring = (
  environment: FrontendEnvironmentSettings
) => {
  if (userMonitoringInitialized || !environment.datadogRUMConfig.enabled) {
    return;
  }

  datadogRum.init({
    applicationId: environment.datadogRUMConfig.applicationId,
    clientToken: environment.datadogRUMConfig.clientToken,
    site: environment.datadogRUMConfig.site,
    service: environment.datadogRUMConfig.serviceName,
    env: environment.environment,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
    trackResources: true,
    trackLongTasks: true,
    beforeSend: event => {
      if (
        event.action &&
        event.action['target'] &&
        event.action['target']['name']
      ) {
        const originalName = event.action['target']['name'] as string;
        if (originalName.startsWith(safeActionPrefix)) {
          event.action['target']['name'] = originalName.slice(
            safeActionPrefix.length
          );
        } else {
          event.action['target']['name'] = 'TARGET OBFUSCATED';
        }
      }
      return true;
    },
  });

  const getOrientation = () => {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  };

  const setOrientationContext = () => {
    datadogRum.setGlobalContextProperty('ui.orientation', getOrientation());
    datadogRum.setGlobalContextProperty('ui.viewport.width', window.innerWidth);
    datadogRum.setGlobalContextProperty(
      'ui.viewport.height',
      window.innerHeight
    );
  };

  //set initial orientation
  setOrientationContext();

  const isIPad = () => {
    const isMac = navigator.userAgent.includes('Macintosh');
    const hasTouch =
      'maxTouchPoints' in navigator && navigator.maxTouchPoints > 1;
    return navigator.userAgent.includes('iPad') || (isMac && hasTouch);
  };

  datadogRum.setGlobalContextProperty('device.is_iPad', isIPad());

  // listen for updates
  if (!orientationListenerInitialized) {
    window.addEventListener('resize', setOrientationContext);
    window.addEventListener('orientationchange', setOrientationContext);
    orientationListenerInitialized = true;
  }
  userMonitoringInitialized = true;
};

interface DatadogTrackingOptions {
  privacyLevel?: DefaultPrivacyLevel;
}

export const generateDatadogTrackingProps = (
  name: string,
  options?: DatadogTrackingOptions
) => {
  const { privacyLevel } = options || {};
  const props = {};
  if (name) {
    props['data-dd-action-name'] = `${safeActionPrefix}${name}`;
  }
  if (privacyLevel) {
    props['data-dd-privacy'] = privacyLevel;
  }
  return props;
};
